import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import { MeProvider } from "./auth.jsx";
import { ThemeProvider, ToastProvider, ValueModeProvider } from "./ui.jsx";
import { ModeProvider } from "./mode.jsx";
import { ConfirmProvider } from "./components/confirm.jsx";
import "./styles.css";

// After a deploy, an already-open tab references hashed chunk files that no longer exist; the next
// lazy import 404s. Recover by reloading ONCE to pull the fresh index.html + chunks (timestamp-guarded
// so it can never loop). Vite fires `vite:preloadError` on such a failure.
window.addEventListener("vite:preloadError", () => {
  const last = +(sessionStorage.getItem("helmChunkReloadAt") || 0);
  if (Date.now() - last < 10000) return;   // just reloaded — don't loop, let the error surface
  sessionStorage.setItem("helmChunkReloadAt", String(Date.now()));
  window.location.reload();
});

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <ValueModeProvider>
          <ToastProvider>
            <ConfirmProvider>
              <MeProvider>
                <ModeProvider>
                  <App />
                </ModeProvider>
              </MeProvider>
            </ConfirmProvider>
          </ToastProvider>
        </ValueModeProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
